<app-nav-menu></app-nav-menu>
<div class="Main_page">
  <p-toast></p-toast>
  <div class="row m-0 p-0">
    <div class="col-md-12 p-0">
      <div class="SearchPannel">
        <div class="row m-0">
          <div class="heading_page">
            <span>Manager Proficiency Report</span>
          </div>
        </div>
        <form #bookingForm="ngForm" (ngSubmit)="onSubmit()">
          <div class="row m-0 mt-3">
            <div class="col-md-11 p-0">
              <div class="row m-0 mt-1">

                <!-- Booking From Date -->
                <div class="col-md-2 p-0">
                  <input type="date"
                    class="new_input_fields"
                    name="fromBookingDate"
                    [(ngModel)]="managerProperties.startDate"
                    #fromBookingDate="ngModel">
                    <label class="input_lab_first">Booking From</label>
                  </div>

                  <!-- Booking To Date (Conditional Requirement) -->
                  <div class="col-md-2 p-0 pl-1">
                    <input type="date"
                      class="new_input_fields"
                      name="toBookingDate"
                      [(ngModel)]="managerProperties.endDate"
                      #toBookingDate="ngModel"
                      [required]="managerProperties.startDate">
                      <label class="input_lab_first">Booking To</label>
                      @if (managerProperties.startDate && toBookingDate.invalid && toBookingDate.touched) {
                        <div class="error">
                          Booking To date is required if Booking From date is selected.
                        </div>
                      }
                    </div>

                    <!-- Optional Booking ID -->
                    <div class="col-md-2 p-0 pl-1">
                      <input type="number"
                        class="new_input_fields"
                        name="bookingID"
                        [(ngModel)]="managerProperties.bookingId">
                        <label class="input_lab_first">Booking ID</label>
                      </div>

                      <!-- Optional Agency Selection -->
                      <div class="col-md-2 p-0 pl-1">
                        <ng-select [items]="agencyCodefinalList$ | async"
                          bindLabel="labelName"
                          bindValue="code"
                          [searchable]="true"
                          class="statusselect"
                          name="byAgency"
                          (blur)="getlistofUsers(managerProperties.agencyBranchId)"
                          [(ngModel)]="managerProperties.agencyBranchId">
                        </ng-select>
                        <label class="input_lab_first">By Agency</label>
                      </div>

                      <!-- Optional Manager Selection -->
                      <div class="col-md-2 p-0 pl-1">
                        <ng-select [items]="userlist"
                          bindLabel="fullname"
                          bindValue="userId"
                          [searchable]="true"
                          class="statusselect"
                          name="loginUserId"
                          [(ngModel)]="managerProperties.modifyUser">
                        </ng-select>
                        <label class="input_lab_first">Manager</label>
                      </div>

                      <!-- Optional Request Type Selection -->
                      <div class="col-md-2 p-0 pl-1">
                        <ng-select [items]="getOfflineRequestTypeList"
                          bindLabel="typeName"
                          bindValue="offlineRequestTypeId"
                          [searchable]="true"
                          class="statusselect"
                          name="loginUserId"
                          [(ngModel)]="managerProperties.offlineBookingRequestId">
                        </ng-select>
                        <label class="input_lab_first">Request Type</label>
                      </div>

                    </div>
                  </div>

                  <!-- Submit Button -->
                  <div class="col-md-1">
                    <button type="submit" class="LoadButton">
                      Load
                      <span class="load loading"></span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>

        </div>
        @if (datasoruceBooking.length>0) {
          <div class="row m-0 p-1">
            <div class="col-md-4 ">
              <div style="background: white; border: 1px solid silver; box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;padding:10px;border-radius:5px">
                <p-chart type="doughnut" [height]="160" [data]="dataStatus" [options]="options"></p-chart>
              </div>
            </div>
            <div class="col-md-4">
              <div style="background: white; border: 1px solid silver; box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;padding:10px;border-radius:5px">
                <p-chart type="doughnut" [height]="160" [data]="dataRequestTypeOnline" [options]="options"></p-chart>
              </div>
            </div>
            <div class="col-md-4 ">
              <div style="background: white; border: 1px solid silver; box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;padding:10px;border-radius:5px">
                <p-chart type="doughnut" [height]="160" [data]="dataRequestTypeOffline" [options]="options"></p-chart>
              </div>
            </div>
          </div>
        }

        <dx-data-grid id="gridContainer"
          [dataSource]="datasoruceBooking"
          [allowColumnReordering]="true"
          [width]="'100%'"
          [showBorders]="true" (onExporting)="onExporting($event)">
          <dxi-column [visible]="false"
            alignment="center"
            caption="Request Type Id"
            dataField="requestType"
          dataType="string"></dxi-column>
          <dxi-column [width]="200"
            caption="Request Type"
            dataField="requestTypeName"
          dataType="string"></dxi-column>
          <dxi-column alignment="center"
            caption="Supplier"
            dataField="bookingSource"
          dataType="string"></dxi-column>
          <dxi-column alignment="center"
            caption="Pnr"
            dataField="pnr"
          dataType="string"></dxi-column>
          <dxi-column alignment="center"
            caption="Trip"
            dataField="sector"
          dataType="string"></dxi-column>
          <dxi-column alignment="center"
            caption="Booking Id"
          dataField="onlineBookingId"></dxi-column>
          <dxi-column alignment="center"
            caption="Ticket No"
            dataField="tktNo"
          dataType="string"></dxi-column>
          <dxi-column alignment="center"
            caption="Action Date"
            dataField="modifydate"
          dataType="string"></dxi-column>
          <dxi-column alignment="center"
            caption="Action User"
            dataField="modifyUser"
          dataType="string"></dxi-column>


          <dxi-column alignment="center"
            caption="Booking date"
            dataField="creationDate"
            dataType="Date"
          format="dd-MM-yyyy"></dxi-column>
          <dxi-column [allowFiltering]="true"
            alignment="center"
            caption="Travel date"
            dataField="travelDate"
            dataType="Date"
          format="dd-MM-yyyy"></dxi-column>
          <dxi-column alignment="center"
            caption="Passenger Name"
            dataField="passName"
          dataType="string"></dxi-column>
          <dxi-column [visible]="false"
            alignment="center"
            caption="Booking Id"
          dataField="offlineBookingId"></dxi-column>
          <dxi-column [visible]="false"
            alignment="center"
            dataField="agencyId"
          dataType="string"></dxi-column>

          <dxi-column [visible]="false"
            alignment="center"
            dataField="onlineBookingId"
          dataType="number"></dxi-column>

          <dxi-column [allowFiltering]="true"
            alignment="center"
            caption="Status"
            dataField="status"
          dataType="string"></dxi-column>
          <dxo-selection mode="multiple"></dxo-selection>
          <dxo-search-panel [visible]="true"></dxo-search-panel>
          <dxo-paging [pageSize]="10"></dxo-paging>
          <dxo-group-panel [visible]="true"></dxo-group-panel>
          <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
          <dxo-export [enabled]="true" [allowExportSelectedData]="true">Export</dxo-export>
        </dx-data-grid>
        <div class="options">
          <div class="caption">Options</div>
          <div class="option">
            <dx-check-box id="autoExpand"
              [(value)]="expand.autoExpandAll"
              text="Expand All Groups">
            </dx-check-box>
          </div>
        </div>

      </div>
